var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.autoLoginToken)?_c('iframe',{staticClass:"hidden",attrs:{"src":("https://dpd.talentprint.com/" + _vm.autoLoginToken)}}):_vm._e(),_c('Header'),_c('Testimonials')],1)}
var staticRenderFns = []

export { render, staticRenderFns }